module.exports = __webpack_public_path__ + "01f43047/img/question-icon.06c20c5d.svg";